var angularModule = angular.module('t2g.common.services.modelService', [
  'ngFileUpload',
  require('t2g.common.data-access.customer').name,
  require('t2g.common.services.cacheService').name,
  require('t2g.common.services.RESTService').name,
  require('t2g.common.services.sessionStorage').name,
]);

module.exports = angularModule;

angularModule.factory('ObjectModel', function(
  $rootScope,
  gettextCatalog,
  Object,
  ObjectCache,
  AppointmentCache,
  ResourceDA,
  Upload,
  UserSession,
) {
  return {
    get: function(callback) {
      var cachedObjects = ObjectCache.get('objects');

      if (typeof cachedObjects === 'undefined') {
        Object.query({ officeId: UserSession.getOffice() }, {}, function(response) {
          if (angular.isArray(response)) {
            ObjectCache.put('objects', response);

            callback(null, response);
          } else {
            callback('Error: cant load object data');
          }
        });
      } else {
        callback(null, cachedObjects);
      }
    },
    getOne: function(resourceId, callback) {
      Object.getOne(
        { objectId: resourceId, officeId: UserSession.getOffice() },
        function(response) {
          callback(null, response);
        },
        function(error) {
          callback('cant getOne resource: ' + error);
        },
      );
    },
    save: function(object, callback) {
      object.office = UserSession.getOffice();

      object.$save(
        function(response) {
          // refresh cache
          var cachedObject = ObjectCache.get('objects') || [];

          cachedObject.push(response);
          ObjectCache.remove('objects');
          ObjectCache.put('objects', cachedObject);

          // clear appointment cache
          AppointmentCache.removeAll();

          ResourceDA.clearCache();

          // inform observers
          $rootScope.$broadcast('Object:save', response);
          callback(null, response);
        },
        function(error) {
          callback(error);
        },
      );
    },
    update: function(object, callback) {
      if (object instanceof Object) {
        object = new Object(object);
      }

      object.office = UserSession.getOffice();

      object.$update(
        function(response) {
          // refresh cache
          var cachedObject = ObjectCache.get('objects');

          if (cachedObject) {
            for (var i = 0, objectsLen = cachedObject.length; i < objectsLen; i++) {
              if (cachedObject[i]._id === response._id) {
                cachedObject[i] = response;
                break;
              }
            }

            ObjectCache.remove('objects');
            ObjectCache.put('objects', cachedObject);
          }

          ResourceDA.clearCache();

          // inform observers
          $rootScope.$broadcast('Object:edit', response);
          callback(null, response);
        },
        function(error) {
          callback(error);
        },
      );
    },
    uploadImage: function(files, object, callback) {
      Upload.upload({
        url: '/api/office/' + object.office + '/objects/' + object._id + '/imageUpload',
        data: angular.toJson(object),
        file: files[0],
      })
        .success(function(response) {
          var cachedObjects = ObjectCache.get('objects') || [];
          var cachedObjectIndex = -1;

          for (var i = 0, objectsLen = cachedObjects.length; i < objectsLen; i++) {
            if (cachedObjects[i]._id === response._id) {
              cachedObjectIndex = i;
              break;
            }
          }

          if (cachedObjectIndex > -1) {
            cachedObjects[cachedObjectIndex] = response;
          } else {
            cachedObjects.push(response);
          }

          // clear cache ...
          ObjectCache.remove('objects');

          // ... and write back data
          ObjectCache.put('objects', cachedObjects);

          // inform observers
          $rootScope.$broadcast('Object:edit', response);
          callback(null, response);
        })
        .error(function(error) {
          callback(error);
        });
    },
    delete: function(object, callback) {
      if (object instanceof Object) {
        object = new Object(object);
      }

      object.$delete(
        function(response) {
          // refresh cache
          var cachedObject = ObjectCache.get('objects');

          if (cachedObject) {
            for (var i = 0; i < cachedObject.length; i++) {
              if (cachedObject[i]._id == response._id) {
                cachedObject.splice(i, 1);
                break;
              }
            }

            ObjectCache.remove('objects');
            ObjectCache.put('objects', cachedObject);
          }

          ResourceDA.clearCache();

          // inform observers
          $rootScope.$broadcast('Object:delete', response);
          callback(null, response);
        },
        function(error) {
          var openAppointments = _.get(error, 'data.error.open_appointments');
          var errorText;

          if (openAppointments) {
            errorText = gettextCatalog.getPlural(
              openAppointments,
              'One open appointment in future for this resource. Please delete the appointment first.',
              '{{$count}} open appointments in future for this resource. Please delete this appointments first.',
              {},
            );
            callback({ text: errorText });
          } else {
            callback(error);
          }
        },
      );
    },
  };
});

angularModule.factory('CustomerModel', function(
  $rootScope,
  Customer,
  CustomerDA,
  CustomerCache,
  UserSession,
) {
  return {
    get: function(callback) {
      var cachedCustomer = CustomerCache.get('customers');

      if (typeof cachedCustomer === 'undefined') {
        CustomerDA.get().then(
          function(customers) {
            CustomerCache.put('customers', customers);
            callback(null, customers);
          },
          function() {
            callback('Error: cant load customer data');
          },
        );
      } else {
        callback(null, cachedCustomer);
      }
    },
    getOne: function(customerId, callback) {
      CustomerDA.get(customerId).then(
        function(customers) {
          CustomerCache.put('customers', customers);
          callback(null, customers);
        },
        function() {
          callback('Error: cant load customer data');
        },
      );
    },
    getAppointments: function(customer, callback) {
      Customer.getAppointments(
        { customerId: customer._id, officeId: UserSession.getOffice() },
        function(response) {
          if (response instanceof Array) {
            callback(null, response);
          } else {
            callback('Error: cant load customer appointments');
          }
        },
      );
    },
    clearCache: function() {
      CustomerCache.remove('customers');
      CustomerDA.clearCache();
    },
    updateCustomers: function(newCustomers) {
      var cachedCustomer = CustomerCache.get('customers') || [];

      cachedCustomer = cachedCustomer.concat(newCustomers);
      CustomerCache.remove('customers');
      CustomerCache.put('customers', cachedCustomer);

      CustomerDA.updateCustomers(newCustomers);
    },
    save: function(customer, callback) {
      if (customer instanceof Object) {
        customer = new Customer(customer);
      }

      customer.customerAt = UserSession.getOffice();

      customer.$save(
        function(response) {
          // refresh cache
          var cachedCustomer = CustomerCache.get('customers');

          if (response.birthday) {
            response.birthday = new Date(response.birthday);
          }

          if (angular.isArray(cachedCustomer)) {
            cachedCustomer.unshift(response);
            CustomerCache.remove('customers');
            CustomerCache.put('customers', cachedCustomer);
          }

          // inform observers
          $rootScope.$broadcast('Customer:save', response);
          callback(null, response);
        },
        function(error) {
          callback('cant insert new customer: ' + error);
        },
      );
    },
    update: function(customer, callback) {
      if (customer instanceof Object) {
        customer = new Customer(customer);
      }
      customer.$update(
        function(response) {
          // refresh cache
          var cachedCustomer = CustomerCache.get('customers') || [];

          if (response.birthday) {
            response.birthday = new Date(response.birthday);
          }

          for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
            if (cachedCustomer[i]._id == response._id) {
              cachedCustomer[i] = response;
              break;
            }
          }

          CustomerCache.remove('customers');
          CustomerCache.put('customers', cachedCustomer);

          // inform observers
          $rootScope.$broadcast('Customer:edit', response);

          callback(null, response);
        },
        function(error) {
          callback('cant insert new customer: ' + error);
        },
      );
    },
    updateCache: function(customer, callback) {
      var updated = false;
      var cachedCustomer = CustomerCache.get('customers') || [];

      for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
        if (cachedCustomer[i]._id == customer._id) {
          cachedCustomer[i] = customer;
          updated = true;
          break;
        }
      }

      if (!updated) {
        cachedCustomer.push(customer);
      }

      CustomerCache.remove('customers');
      CustomerCache.put('customers', cachedCustomer);

      // inform observers
      $rootScope.$broadcast('Customer:edit', customer);

      callback(null);
    },
    delete: function(customer, callback) {
      if (customer instanceof Object) {
        customer = new Customer(customer);
      }

      customer.$delete(
        function(response) {
          // refresh cache
          var cachedCustomer = CustomerCache.get('customers');

          console.log('#1');
          console.log(cachedCustomer);

          if (angular.isArray(cachedCustomer)) {
            for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
              if (cachedCustomer[i]._id == response._id) {
                console.log('found');
                cachedCustomer.splice(i, 1);
                break;
              } else {
                console.log('not found');
              }
            }
          }

          CustomerCache.remove('customers');
          CustomerCache.put('customers', cachedCustomer);

          // inform observers
          $rootScope.$broadcast('Customer:delete', response);
          callback(null, response);
        },
        function(error) {
          callback('cant delete new customer: ' + error);
        },
      );
    },
  };
});

angularModule.factory('AccountModel', function(
  $timeout,
  Account,
  UserSession,
  LocalStorage,
  settings,
) {
  return {
    changePassword: function(account, callback) {
      if (account instanceof Object) {
        account = new Account(account);
      }

      account.$changePassword(function(response) {
        callback(null, response);
      });
    },
    logout: function(account) {
      if (account instanceof Object) {
        account = new Account(account);
      }

      LocalStorage.remove('countryConfig');
      LocalStorage.remove('openDay');

      UserSession.clean();

      $timeout(function() {
        account.$logout(function() {
          window.location = settings.login;
        });
      });
    },
  };
});

angularModule.factory('OfficeModel', function($rootScope, Office, OfficeCache, UserSession) {
  return {
    get: function(callback) {
      var cachedOffice = OfficeCache.get('office');

      if (typeof cachedOffice === 'undefined') {
        Office.get({ officeId: UserSession.getOffice() }, {}, function(response) {
          if (response instanceof Object) {
            OfficeCache.put('office', response);

            var userSession = UserSession.get();

            if (response.billing) {
              userSession.account = response.billing.account;
            }

            UserSession.set(userSession, function() {
              callback(null, response);
            });
          } else {
            callback('Error: cant load office data');
          }
        });
      } else {
        callback(null, cachedOffice);
      }
    },
    removeLogo: function(office, callback) {
      Office.removeLogo(
        function(response) {
          callback(null, response);
        },
        function(error) {
          callback('cant remove profile logo: ' + error);
        },
      );
    },
    update: function(office, callback) {
      Office.update(
        { officeId: UserSession.getOffice() },
        office,
        function(response) {
          OfficeCache.remove('office');
          OfficeCache.put('office', response);
          $rootScope.$broadcast('Office:update', response);
          callback(null, response);
        },
        function(error) {
          callback('cant update office data: ' + error);
        },
      );
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/services/ModelService.js